export default {
  API_BASE_URL: 'https://api.cardano.scantrust.io',
  ST_API_BASE_URL: 'https://api.scantrust.com/api/v2'
}
